import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import KobooTextField from '../Layout/KobooTextField.jsx';
import defaultStyles from '../../constants/stylesDefault';

export class SiteSlot extends Component {
  static propTypes = {
    slot: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    cumulateTime: PropTypes.number.isRequired,
    cumulatePrice: PropTypes.number.isRequired,
    onChangePrice: PropTypes.func.isRequired,
    onChangeTime: PropTypes.func.isRequired,
    isLast: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
  };

  state = {
    price: this.props.slot.price,
    time: this.props.slot.time
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if ( state.price && parseFloat(state.price) !== parseFloat(props.slot.price) ) {
      props.onChangePrice(state.price, props.index);
    }
    if ( state.time && parseInt(state.time, 10) !== parseInt(props.slot.time, 10) ) {
      props.onChangeTime(state.time, props.index);
    }

    return newState;
  }

  render() {
    const { index, cumulateTime, cumulatePrice, isLast } = this.props;
    const {
      time,
      price
    } = this.state;
    return (
      <Grid container key={index}>
        <KobooTextField
          label="Début du créneau"
          id={"start_" + index}
          value={cumulateTime+" min"}
          md={2}
          disabled={true}
        />
        <KobooTextField
          label="Durée du créneau"
          id={"duration_" + index}
          onChange={event => this.setState({time: event.target.value})}
          type="number"
          value={time}
          md={2}
        />
        <KobooTextField
          label="Tarif créneau (€)"
          id={"price_" + index}
          onChange={event => this.setState({price: event.target.value})}
          type="number"
          value={price}
          md={2}
        />
        <KobooTextField
          label="Coût de la location"
          id={"cost_" + index}
          value={cumulatePrice.toFixed(2)+" €"}
          md={2}
          disabled={true}
        />
        {isLast && index > 0 &&
          <input
            style={defaultStyles.input}
            type="image"
            src="/moins.svg"
            alt="Supprimer"
            title="Supprimer"
            onClick={this.props.onRemove}
          />
        }
        {isLast &&
        <input
          style={defaultStyles.input}
          type="image"
          src="/plus.svg"
          alt="Ajouter"
          title="Ajouter"
          onClick={this.props.onAdd}
        />
        }
      </Grid>
    );
  }
}

export default SiteSlot;



// WEBPACK FOOTER //
// ./src/components/Site/SiteSlot.jsx